import { Button, Drawer, Form, Input, InputNumber, Select, Space } from "antd";
import axios from "axios";
import React, { useContext, useState } from "react";
import { NotificationInfo, UserInfo } from "../../../context";

const { Option } = Select;

const CommissaryAddRaw = ({
  open,
  close,
  setLoading,
  getRawProductList,
  unitList,
  categoryList,
}) => {
  // const [unitList, setUnitList] = useState({ data: [], ready: false });
  const { rerunNotif } = useContext(NotificationInfo);
  const [loadings, setLoadings] = useState(false);
  const { userData } = useContext(UserInfo);
  const [form] = Form.useForm();

  const handleCreateRawProduct = (values) => {
    const formdata = new FormData();
    formdata.append("user_id", userData.data.id);
    for (const name in values) {
      formdata.append(name, values[name]);
    }
    setLoadings(true);
    setLoading(true);
    axios
      .post("user/commissary/new-raw-product", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "Created new raw product successfully.");
          setTimeout(() => {
            close();
            form.setFieldsValue({
              sku: "",
              product: "",
              description: "",
              msrp: "",
              srp: "",
            });
            setLoadings(false);
            setLoading(false);
            getRawProductList();
          }, 1000);
        }
      })
      .catch((error) => {
        setLoadings(false);
      });
    // console.log("FORMDATA", formdata);
  };

  // const getAllUnits = useCallback(() => {
  //   var params = { user_id: userData.data.id };
  //   axios
  //     .get("user/commissary/unit-list", { params })
  //     .then((response) => {
  //       const data = response.data;
  //       setUnitList({ data, ready: true });
  //     })
  //     .catch((error) => {
  //       console.log("ERROR: ", error);
  //     });
  // }, [userData.data.id]);

  // useEffect(() => {
  //   getAllUnits();
  // }, [getAllUnits]);

  return (
    <Drawer
      title="Create Raw Product"
      // width={500}
      onClose={close}
      open={open}
      bodyStyle={{
        paddingBottom: 80,
      }}
    >
      <Form
        form={form}
        layout="vertical"
        name="basic"
        initialValues={{
          sku: "",
          product: "",
          description: "",
          msrp: "",
          srp: "",
        }}
        onFinish={handleCreateRawProduct}
        autoComplete="off"
      >
        <Space direction="vertical" style={{ width: "100%", margin: 0 }}>
          <Form.Item
            name="is_production"
            label="For Production?"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <Select
              placeholder="Select"
              size="large"
              showSearch
              filterOption={(input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
            >
              <Option value={0}>No</Option>
              <Option value={1}>Yes</Option>
            </Select>
          </Form.Item>

          <Form.Item
            name="sku"
            label="SKU"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <Input placeholder="Set SKU" size="large" />
          </Form.Item>

          <Form.Item
            name="product"
            label="Raw Product Name"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <Input placeholder="Set product name" size="large" />
          </Form.Item>

          <Form.Item
            name="description"
            label="Raw Product Description"
            rules={[
              {
                required: false,
                message: "Required",
              },
            ]}
          >
            <Input placeholder="Set product description" size="large" />
          </Form.Item>

          <Form.Item
            name="unit"
            label="Raw Unit Per Consumption"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <Select
              placeholder="Select unit"
              size="large"
              showSearch
              filterOption={(input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
            >
              {unitList.data.length > 0 ? (
                unitList.data.map((data, index) => (
                  <Option value={data.id} key={index}>
                    {data.unit}
                  </Option>
                ))
              ) : (
                <Option value="">No unit found!</Option>
              )}
            </Select>
          </Form.Item>

          <Form.Item
            name="category"
            label="Raw Category"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <Select
              placeholder="Select category"
              size="large"
              showSearch
              filterOption={(input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
            >
              {categoryList.data.length > 0 ? (
                categoryList.data.map((data, index) => (
                  <Option value={data.id} key={index}>
                    {data.category}
                  </Option>
                ))
              ) : (
                <Option value="">No category found!</Option>
              )}
            </Select>
          </Form.Item>

          <Form.Item
            name="purchase_price"
            label="Purchase Price Per Consumption"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <InputNumber
              min={0}
              max={999999999999}
              initialvalues={0}
              size="large"
              style={{ width: "100%" }}
              step="0.01"
            />
          </Form.Item>

          <Form.Item
            name="msrp"
            label="Raw Product MSRP Per Consumption"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <InputNumber
              min={0}
              max={999999999999}
              initialvalues={0}
              size="large"
              style={{ width: "100%" }}
              step="0.01"
            />
          </Form.Item>

          <Form.Item
            name="srp"
            label="Raw Product SRP Per Consumption"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <InputNumber
              min={0}
              max={999999999999}
              initialvalues={0}
              size="large"
              style={{ width: "100%" }}
              stringMode
              step="0.01"
            />
          </Form.Item>
        </Space>

        <Form.Item style={{ marginTop: "20px" }}>
          <Button
            type="primary"
            loading={loadings}
            htmlType="submit"
            style={{ width: "100%", borderRadius: "20px" }}
          >
            {loadings ? "Loading" : "Create"}
          </Button>
        </Form.Item>
      </Form>
    </Drawer>
  );
};

export default CommissaryAddRaw;
